import { render, staticRenderFns } from "./CourseSelector.vue?vue&type=template&id=67089875&"
import script from "./CourseSelector.vue?vue&type=script&lang=js&"
export * from "./CourseSelector.vue?vue&type=script&lang=js&"
import style0 from "./CourseSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports